import { render, staticRenderFns } from "./Game.vue?vue&type=template&id=6ca3af22&scoped=true&"
import script from "./Game.vue?vue&type=script&lang=js&"
export * from "./Game.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca3af22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\Node\\megadrive\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ca3af22')) {
      api.createRecord('6ca3af22', component.options)
    } else {
      api.reload('6ca3af22', component.options)
    }
    module.hot.accept("./Game.vue?vue&type=template&id=6ca3af22&scoped=true&", function () {
      api.rerender('6ca3af22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Game.vue"
export default component.exports